import { render, staticRenderFns } from "./TherapyStart.vue?vue&type=template&id=07987e91"
import script from "./TherapyStart.vue?vue&type=script&lang=js"
export * from "./TherapyStart.vue?vue&type=script&lang=js"
import style0 from "./TherapyStart.vue?vue&type=style&index=0&id=07987e91&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports